export const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] as const;

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;

export const announcableCardinalDays = {
  1: 'first',
  2: 'second',
  3: 'third',
  4: 'fourth',
  5: 'fifth',
  6: 'sixth',
  7: 'seventh',
  8: 'eighth',
  9: 'ninth',
  10: 'tenth',
  11: 'eleventh',
  12: 'twelfth',
  13: 'thirteenth',
  14: 'fourteenth',
  15: 'fifteenth',
  16: 'sixteenth',
  17: 'seventeenth',
  18: 'eighteenth',
  19: 'ninteenth',
  20: 'twentieth',
  21: 'twenty first',
  22: 'twenty second',
  23: 'twenty third',
  24: 'twenty fourth',
  25: 'twenty fifth',
  26: 'twenty sixth',
  27: 'twenty seventh',
  28: 'twenty eighth',
  29: 'twenty ninth',
  30: 'thirtieth',
  31: 'thirty first',
} as const;

export const defaultMetaInfo = { isAutomaticFillTrigger: false };
